export const environment = {
  production: true,
  url_base: 'https://opticaslince.com/'
};
